<template>
  <el-dialog
    title="Add clinic"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    width="480px"
    @close="resetForm"
  >
    <div class="add-clinic-modal">
      <label class="add-clinic-modal__field">
        <span class="add-clinic-modal__label">
          Clinic website
          <span class="add-clinic-modal__required">*</span>
        </span>
        <el-input
          v-model="form.url"
          placeholder="https://example-clinic.com/"
        />
      </label>

      <label class="add-clinic-modal__field">
        <span class="add-clinic-modal__label">Instagram URL</span>
        <el-input
          v-model="form.instagram_url"
          placeholder="https://instagram.com/clinic"
        />
      </label>
    </div>

    <div slot="footer" class="add-clinic-modal__footer">
      <base-button type="default" @click="cancel">Cancel</base-button>
      <base-button
        type="primary"
        :disabled="!form.url || isSubmitting"
        @click="submit"
      >
        {{ isSubmitting ? 'Submitting...' : 'Submit' }}
      </base-button>
    </div>
  </el-dialog>
</template>

<script>
import Analytics from '@/api/modules/analytics';

const buildForm = () => ({
  url: '',
  instagram_url: '',
});

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      form: buildForm(),
      isSubmitting: false,
    }),
    computed: {
      isVisible: {
        get() {
          return this.show;
        },
        set(value) {
          this.$emit('update:show', value);
        },
      },
    },
    methods: {
      cancel() {
        this.isVisible = false;
      },
      buildPayload() {
        const payload = { url: this.form.url };

        if (this.form.instagram_url) {
          payload.instagram_url = this.form.instagram_url;
        }

        return payload;
      },
      async submit() {
        if (!this.form.url || this.isSubmitting) {
          return;
        }
        this.isSubmitting = true;

        try {
          const response = await Analytics.parseClinicFromSite(this.buildPayload());
          this.$emit('submit', response.data);
          this.$notify({ type: 'success', title: 'Clinic parsing started' });
          this.isVisible = false;
        } catch (error) {
          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to start clinic parsing';
          this.$notify({ type: 'warning', title: message });
        } finally {
          this.isSubmitting = false;
        }
      },
      resetForm() {
        this.form = buildForm();
        this.isSubmitting = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .add-clinic-modal {
    display: flex;
    flex-direction: column;
    gap: 14px;
    &__field {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    &__label {
      font-size: 13px;
      color: #555;
    }
    &__required {
      color: #ec250d;
    }
    &__footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
  }
</style>